<div class="flex w-full flex-col gap-4" data-test-id="promotion-code-form">
	<sb-heading-group
		[overline]="'storyblok.pages.promotion-code.form.overline' | translate"
		[title]="'storyblok.pages.promotion-code.form.title' | translate"
		headingType="h2"
	/>
	<p class="mb-0" data-test-id="form-content">
		{{ 'storyblok.pages.promotion-code.form.description' | translate }}
	</p>
	<form
		[formGroup]="formGroup"
		(ngSubmit)="onSubmit()"
		data-test-id="promo-form"
		id="promo-form"
	>
		<formly-form
			[fields]="formFields"
			[form]="formGroup"
			[(model)]="formModel"
		/>
		<button
			[disabled]="requestSubmitting()"
			[ngClass]="{
				'btn-is-loading': requestSubmitting(),
			}"
			class="btn btn-primary w-full"
			data-test-id="request-button"
			type="submit"
		>
			{{ 'storyblok.pages.promotion-code.form.submit' | translate }}
		</button>
	</form>
</div>
